<template>
  <div
    class="d-inline"
    @click="openDrawer()"
  >
    <slot name="activator" />
  </div>
</template>

<script>
import qz from '@/../own_modules/qz-tray/qz-tray'
import { mapState } from 'vuex'
import cashRegisterService from '@/services/cash-registers'

export default {
  name: 'DrawerOpener',

  data: () => ({
    reasonForOpening: ''
  }),

  computed: {
    ...mapState(['printer', 'identifier'])
  },

  methods: {
    showPromptBeforeOpen () {
      this.$swal({
        input: 'text',
        inputPlaceholder: this.$t('Why should the drawer be opened?'),
        showCancelButton: true,
        cancelButtonText: this.$t('Cancel'),
        confirmButtonText: this.$t('Open'),
        allowOutsideClick: false,
        reverseButtons: true,
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value.length > 3) {
              this.reasonForOpening = value
              resolve()
            } else {
              resolve(this.$t('You need to type something here!'))
            }
          })
        }
      })
        .then((result) => {
          // if a value has been typed
          if (result.value) {
            this.openDrawer()
          }
        })
    },
    openDrawer () {
      const interval = setInterval(() => {
        if (qz.websocket.isActive()) {
          const config = qz.configs.create(this.printer || this.defaultPrinter)
          const data = [`\x10\x14\x01\x00\x05`]
          qz.print(config, data)
            .then(() => {
              cashRegisterService.opened(this.identifier, this.reasonForOpening)
            })
          clearInterval(interval)
        }
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DrawerOpener.vue